module.exports = __webpack_public_path__ + "static/media/zapsplat_cartoon_pop_mouth_016_46679.f4051d60.mp3";